import { Box, SxProps } from '@mui/material';
import { BackButton } from 'components/Buttons';
import { Header } from 'components/Header';
import { ChannelsAvailability } from 'modules/channels/components';
import {
  layoutContainerPaddingBottom,
  layoutContainerPaddingTop,
  layoutContainerPaddingX
} from 'services/navigation/components/PrivateRoute';

const container: SxProps = {
  pt: layoutContainerPaddingTop,
  pb: layoutContainerPaddingBottom,
  px: layoutContainerPaddingX
};

export const ChannelsPage = () => {
  return (
    <Box sx={container}>
      <Header
        title="Channels"
        subtitle="Manage how you communicate with candidates"
      />

      <BackButton />

      <ChannelsAvailability />
    </Box>
  );
};
